import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util'

const container = theme => css`
  margin: 0 auto ${rem(20)};
  color: ${theme.color.info[900]};
  max-width: ${rem(396)};
`

const field = theme => css`
  && {
    max-width: 100%;

    &:hover {
      & > * {
        border-color: ${theme.color.primary.info};
      }
    }
    .focused {
      border-color: ${theme.color.primary.info};
    }
    input {
      height: ${rem(48)};
      padding-left: ${rem(16)};
      font-size: ${theme.fontSize.x2large};

      &::placeholder {
        opacity: 0.5;
      }

      & + button {
        margin-right: ${rem(18)};
      }
    }
  }
`

const submitButton = theme => css`
  width: 100%;
  border-radius: ${rem(24)};
  font-family: ${theme.font.secondary};
  font-weight: ${theme.fontWeight.normal};
`

const requirements = theme => css`
  justify-content: space-between;

  li {
    width: ${rem(180)};
    font-size: ${theme.fontSize.base};
  }
`

export const styles = {
  container,
  field,
  submitButton,
  requirements,
}
